import { HTTP } from '@/http-common'

function getRatePlan (ratePlanId) {
  return HTTP.get('/rate-plans/' + ratePlanId)
}

function addRatePlan (ratePlanData) {
  let data = JSON.stringify(ratePlanData)

  return HTTP.post('/rate-plans', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateRatePlan (ratePlanData) {
  let data = JSON.stringify(ratePlanData)

  return HTTP.put('/rate-plans/' + ratePlanData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteRatePlan (ratePlanId) {
  return HTTP.delete('/rate-plans/' + ratePlanId)
}

export { getRatePlan, addRatePlan, updateRatePlan, deleteRatePlan }



// WEBPACK FOOTER //
// ./src/services/rate_plan.service.js